import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import WithAuth from '../../HOCs/WithAuth'
import HomePageOption from '../../components/HomePageOption'

import {
  userIsStudyCoordinator,
  userIsInvestigator,
  userIsPortalAdmin,
  userIsPharmaVigilance,
  userCanSeeAllRoutes,
  userIsSuperUser,
} from '../../functions/userPermissions'

import './style.css'
import submittedChartsImg from "../../static/images/chart-8.png";

const chartsImg = require('../../static/images/chart-9.png')
const analyticsImg = require('../../static/images/analytics.png')
const adverseEventsImg = require('../../static/images/adverse-events.png')


const HomeContainer = (props) => {
  const { currentUser } = props

  return (
    <div id='HomeContainer'>
      <Row>
        {userIsStudyCoordinator(currentUser) || userIsInvestigator(currentUser) || userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) ?
          <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
            <HomePageOption
              image={chartsImg}
              title='Patient Charts'
              description="Create, review, and revise patient charts"
              buttonText="View Charts"
              onClick={() => props.routerProps.history.push('/charts')}
            />
          </Col>
          :
          null
        }


        {userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) || currentUser.can_view_statistics ?
          <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
            <HomePageOption
              image={analyticsImg}
              title='Statistics'
              description="View chart statistics by site, country, and region"
              buttonText="View Statistics"
              onClick={() => props.routerProps.history.push('/statistics')}
            />
          </Col>
          :
          null
        }

        {userIsPortalAdmin(currentUser) || userIsPharmaVigilance(currentUser) || userCanSeeAllRoutes(currentUser) ?
          <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
            <HomePageOption
              image={adverseEventsImg}
              title='Adverse Drug Reactions'
              description="View any adverse drug reactions that were reported on charts in your region"
              buttonText="View Adverse Drug Reactions"
              onClick={() => props.routerProps.history.push('/adverse-drug-reactions')}
            />
          </Col>
          :
          null
        }

        {userIsSuperUser(currentUser) === true ?
              <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
                <HomePageOption
                  image={submittedChartsImg}
                  title='All Charts'
                  description="View all charts for your region"
                  buttonText="All Charts"
                  onClick={() => props.routerProps.history.push('/charts/all')}
                />
              </Col>
              :
              null
            }

      </Row>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
  }
}

export default WithAuth(connect(mapStateToProps)(HomeContainer))
